/**
 * Favorites, groups and events (decision 201): one screen off the You screen, `/you/gatherings`, its
 * tab in the address so the You header's links, the map's filters and Notifications each open theirs.
 */
export const YOURS_TABS = ['favorites', 'groups', 'events'] as const
export type YoursTab = (typeof YOURS_TABS)[number]
export type YoursSearch = { tab?: YoursTab; fav?: 'cruisers' | 'spots' }

/** The route's search, as the router reads it: no tab (or one it doesn't know) opens on Favorites. */
export function yoursSearch(s: Record<string, unknown>): YoursSearch {
  return {
    tab: YOURS_TABS.includes(s.tab as YoursTab) ? (s.tab as YoursTab) : undefined,
    fav: s.fav === 'cruisers' || s.fav === 'spots' ? s.fav : undefined,
  }
}

/** Where a link to one tab goes. */
export const yoursLink = (tab: YoursTab) => ({ to: '/you/gatherings' as const, search: { tab } })

/** The old Favorites page, `/you/favorites`, now the Favorites tab: where it sends you. */
export const OLD_FAVORITES = yoursLink('favorites')
